module.exports = __webpack_public_path__ + "img/BloodyMaryGirl.50dbc8d4.jpeg";